<script>

    import { createEventDispatcher } from 'svelte'
    import { scale, blur } from 'svelte/transition'

    const dispatch = createEventDispatcher()

    export let loading = false
    export let icon = 'trash'
    export let text = 'Borrar'
    export let size = ''
    export let fullwidth = false

    let isClick = false

    function onClick() {

        if(!isClick) {

            setTimeout(() => {
                isClick = false
            }, 2000)

            return isClick = true
        }

        dispatch('confirm')
    }

</script>

<button on:click={onClick} type="button" class="button is-{size}" class:is-danger={isClick} class:is-loading={loading} class:is-fullwidth={ fullwidth } >
    <span class="icon"><i class="fas fa-{icon}"></i></span>
    {#if isClick}
        <span in:scale>Click para confirmar</span>
    {:else}
        <span in:blur>{text}</span>
    {/if}
</button>